/// <amd-module name="Artifacts/Maven/commands/UpstreamOverride" />

import { MavenActions } from "Artifacts/Maven/redux";
import { getUpstreamOverrideCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createUpstreamOverrideCommand = getUpstreamOverrideCommandCreator(
  MavenActions.setUpstreamOverride,
);
